// extracted by mini-css-extract-plugin
module.exports = {"component":"search_component_26Ksf"};